import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Our Wines',
  href: '#'
}, {
  label: 'Our Club',
  href: '#'
}, {
  label: 'Visit Us',
  href: '#'
}, {
  label: 'Our Story',
  href: '#'
}, {
  label: 'Sustainability',
  href: '#'
}, {
  label: 'Contact',
  href: '#'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const heroThreshold = window.innerHeight * 0.8;
      // Toggle scrolled state at 80% of hero height
      setIsScrolled(currentScrollY > heroThreshold);
      // Hide/show on scroll direction (only when in scrolled mode)
      if (currentScrollY > heroThreshold) {
        if (currentScrollY > lastScrollY && currentScrollY > heroThreshold + 80) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  // Close mobile menu when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-30 transition-all duration-300 ease-in-out
        ${isScrolled ? `bg-white border-b border-gray-100 shadow-sm ${isVisible ? 'translate-y-0' : '-translate-y-full'}` : 'bg-transparent'}
      `} data-id="element-92">
      <div className={`w-full px-6 md:px-12 transition-all duration-300
        ${isScrolled ? 'h-[60px] flex items-center justify-between' : 'pt-6 pb-4 flex flex-col items-center'}
      `} data-id="element-93">
        {/* --- DESKTOP LAYOUT --- */}

        {/* Logo Section */}
        <div className={`relative z-20 transition-all duration-300 
          ${isScrolled ? 'order-1 flex-shrink-0' : 'mb-6'}
        `} data-id="element-94">
          <a href="#" className="block hover:opacity-80 transition-opacity" data-id="element-95">
            <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/Logo-GLE.png" alt="Glenlofty" className={`w-auto transition-all duration-300
                ${isScrolled ? 'h-8 md:h-10' : 'h-16 md:h-20 brightness-0 invert'}
              `} data-id="element-96" />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className={`hidden md:flex transition-all duration-300
          ${isScrolled ? 'order-2 flex-1 justify-center' : 'w-full justify-center border-t border-white/20 pt-6'}
        `} data-id="element-97">
          <ul className={`flex items-center ${isScrolled ? 'gap-8' : 'gap-12'}`} data-id="element-98">
            {NAV_LINKS.map(link => <li key={link.label} data-id="element-99">
                <a href={link.href} className={`text-[13px] font-optima font-medium uppercase tracking-[0.15em] transition-colors duration-300
                    ${isScrolled ? 'text-charcoal hover:text-gold' : 'text-white hover:text-white/70'}
                  `} data-id="element-100">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        {/* Placeholder for right side balance in scrolled mode */}
        {isScrolled && <div className="hidden md:block w-8 md:w-10 order-3" data-id="element-101"></div>}

        {/* --- MOBILE LAYOUT --- */}

        {/* Mobile Hamburger (Absolute positioned to stay consistent) */}
        <div className="md:hidden absolute right-6 top-1/2 -translate-y-1/2 z-30" data-id="element-102">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 transition-colors duration-300
              ${isScrolled ? 'text-charcoal' : 'text-white'}
            `} aria-label="Toggle menu" data-id="element-103">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-104" /> : <Menu className="w-6 h-6" data-id="element-105" />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      <div className={`md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg overflow-hidden transition-all duration-300 ease-in-out
          ${isMobileMenuOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}
        `} data-id="element-106">
        <nav className="flex flex-col py-6 px-6" data-id="element-107">
          {NAV_LINKS.map(link => <a key={link.label} href={link.href} className="py-3 text-center text-[14px] font-optima font-medium uppercase tracking-[0.15em] text-charcoal hover:text-gold transition-colors border-b border-gray-50 last:border-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-108">
              {link.label}
            </a>)}
        </nav>
      </div>
    </header>;
}